<div *ngIf="cargando && !cargandoSpinnerPagar" class="d-flex justify-content-center mt-5">
    <div class="col-9 text-center mt-5">
        <img src="../../assets/img/mascota-loader.png" style="max-width: 200px;" alt="" class="mb-3">
        <ngb-progressbar type="success" [value]="progreso"></ngb-progressbar>
    </div>
</div>
<div *ngIf="cargandoSpinnerPagar" class="d-flex justify-content-center mt-5">
    <div class="col-9 text-center mt-5">
        <img src="../../assets/img/mascota-loader.png" style="max-width: 200px;" alt="" class="mb-3">
        <ngb-progressbar type="success" [value]="progreso"></ngb-progressbar>
    </div>
</div>
<div *ngIf="!cargando && !cargandoSpinnerPagar" class="d-flex justify-content-center px-0 mx-0 mt-5">
    <div class="col col-lg-8">
        <!-- Header -->
        <div class="d-flex justify-content-between align-items-center bg-secondary text-white p-3">
            <label class="fs-5 m-0"><span class="vag-bold-font text-uppercase">Inscripción</span> Documentos</label>
            <button (click)="logout()" type="button" class="d-inline-flex btn btn-outline text-white">
                <label class="d-none d-md-block mr-3 fs-5">Salir</label>
                <fa-icon [icon]="powerOffIcon" size="lg" class="text-white"></fa-icon>
            </button>
        </div>
        <div class="menu-cabecera d-flex justify-content-center">
            <div class="col col-lg-8">
                <img src="../../assets/img/step4.png" style="max-width: 100%;" alt="">
            </div>
        </div>

        <!-- CONTENT -->
        <div class="mb-5">
            <div *ngIf="banderaFinalizacion">
                <div class="d-block d-md-flex justify-content-between bg-lightblue text-white py-2 px-3">
                    <label class="fs-5">Selección <span class="vag-bold-font text-uppercase">MÉTODO DE
                            PAGO</span></label>
                    <label class="fs-5" *ngIf="tutorAux?.time != null">Plaza garantizada <span
                            class="vag-bold-font ml-3">{{tutorAux?.time?.minutes}}:{{tutorAux?.time?.seconds}}</span></label>
                </div>
                <div [hidden]="!banderaBotonSiguiente">
                    <div class="div_check" [formGroup]="validacionTipo">
                        <mat-radio-group *ngFor="let tipo of tipoPagoList">
                            <div class="custom-control custom-radio">
                                <label for="{{tipo.name}}" class="radio-inline">
                                    <input id="{{tipo.id}}" [value]="tipo.id" formControlName="tipoPago" type="radio"
                                        name="tipoPago">

                                    <label *ngIf="tipo.id == 'tarjeta'" class="ml-2 fs-5">Tarjeta - Aplica promoción <a
                                            href="#" class="text-secondary" for="flexCheckDefault" data-toggle="modal"
                                            data-target="#exampleModal2"><u>Tarjeta 5</u></a></label>

                                    <label *ngIf="tipo.id != 'tarjeta'" [innerHTML]="tipo.name"
                                        class="ml-2 fs-5"></label>
                                </label>
                            </div>
                        </mat-radio-group>
                    </div>

                    <div class="d-flex justify-content-between py-2">
                        <button [routerLink]="['../contrato']" type="button" (click)="actualizarIdTutor()"
                            class="btn btn-outline-secondary btn-lg">Atrás</button>
                        <div [hidden]="!selectFormaPago">
                            <button type="button" class="btn btn-secondary btn-lg" (click)="banderaBotonSiguiente=false"
                                [disabled]="!validacionTipo.value"
                                [ngClass]="{'opacity-1': !validacionTipo.value}">Siguiente</button>
                        </div>    
                    </div>

                </div>

                <div *ngIf="!banderaBotonSiguiente">
                    <div class="d-flex align-items-center flex-column px-3 py-2 mt-3">
                        <div class="subtitle_center_azul">
                            <h1>Resúmen</h1>
                        </div>
                        <div class="col-md-7 p-0 caja_central">
                            <table class="table">
                                <thead class="bg-lightblue text-white">
                                    <tr>
                                        <th class="fs-4 pl-4">Conceptos</th>
                                        <th class="fs-4 text-right pr-4">Importes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let alumnoItem of alumnos ;let iAlum=index">
                                        <tr>
                                            <td class="border-0 text-lightblue vag-bold-font text-uppercase">
                                                {{alumnoItem.fullname}}</td>
                                        </tr>
                                        <tr *ngFor="let concepto of alumnoItem.billable ; let iConcep= index">
                                            <td class="border-0 pl-4">{{concepto.billableConceptsDescription}}</td>
                                            <td class="border-0 text-right pr-4">{{concepto.netPayment |
                                                currency:'EUR':true}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="2" class="pl-4 text-right fs-5"><span
                                                    class="text-lightblue mr-3">Subtotal</span> <span
                                                    class="vag-bold-font">{{alumnoItem.valorTotalAPagar |
                                                    currency:'EUR':true}}</span></td>
                                        </tr>
                                        <!-- <tr>
                                            <td colspan="2" class="pl-4 text-right fs-5"><span
                                                    class="text-lightblue mr-3">Total
                                                    descuento</span> <span
                                                    class="vag-bold-font">{{alumnoItem.totalDescuentos |
                                                    currency:'EUR':true}}</span></td>
                                        </tr> -->
                                    </ng-container>
                                    <tr>

                                        <td colspan="2" class="pl-4 text-right fs-3"><span
                                                class="text-lightblue mr-3">Total
                                                a
                                                pagar</span> <span class="vag-bold-font">{{valorTotalAPagar |
                                                currency:'EUR':true}}</span></td>
                                    </tr>
                                </tbody>
                            </table>

                        </div>
                    </div>


                    <div class="pt-4" *ngIf="visibleSepa">
                        <div class="text-center text-lg-left text-lightblue">
                            <h4>Formulario SEPA</h4>
                        </div>
                        <div class="d-block d-md-flex">
                            <div class="col col-md-3 mb-3">
                                <div class="form-group">
                                    <label class="label_title_textfield text-truncate fs-5">Nombre/apellidos
                                        deudor</label>
                                    <input [(ngModel)]="tutor.titularPayment" type="text" class="form-control fs-5"
                                        [formControl]="campoNombre" placeholder="" aria-describedby="basic-addon1">
                                </div>
                            </div>
                            <div class="col col-md-3 mb-3">
                                <div class="form-group">
                                    <label class="label_title_textfield text-truncate fs-5">Documento</label>
                                    <select class="form-control fs-5" [(ngModel)]="tutor.documentTitular"
                                        (ngModelChange)="onChangeDocumento($event)">
                                        <option value="DNI" selected="selected">DNI</option>
                                        <option value="NIE">NIE</option>
                                        <option value="Pasaporte">Pasaporte</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col col-md-3 mb-3">
                                <div class="form-group">
                                    <label class="label_title_textfield text-truncate fs-5">Número</label>
                                    <input [(ngModel)]="tutor.numberDNITitular" type="text" class="form-control fs-5"
                                        [formControl]="campoNumeroDocumento" placeholder=""
                                        (ngModelChange)="tutor.numberDNITitular= $event?.toUpperCase() ; validarDoc(tutor.numberDNITitular)"
                                        aria-describedby="basic-addon1">
                                    <div *ngIf="(campoNumeroDocumento.invalid || !documentoValido) && (campoNumeroDocumento.dirty || campoNumeroDocumento.touched)"
                                        class="alert alert-danger">
                                        <div>
                                            Docúmento invalido
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col col-md-3 mb-3">
                                <div class="form-group">
                                    <label class="label_title_textfield text-truncate fs-5">Dirección</label>
                                    <input [(ngModel)]="tutor.addressTitular" type="text" class="form-control fs-5"
                                        [formControl]="campoDireccion" placeholder="" aria-describedby="basic-addon1">
                                </div>
                            </div>
                        </div>
                        <div class="d-block d-md-flex">
                            <div class="col col-md-3 mb-3">
                                <div class="form-group">
                                    <label class="label_title_textfield text-truncate fs-5">Código postal</label>
                                    <input [(ngModel)]="tutor.zipTitular" type="text" class="form-control fs-5"
                                        [formControl]="campoZip" placeholder=""
                                        onKeyPress="if(this.value.length==5) return false;" maxlength="5"
                                        (ngModelChange)="obtenerMunicipioXCodigoPostal(tutor.zipTitular)"
                                        aria-describedby="basic-addon1">
                                </div>
                            </div>
                            <div class="col col-md-3 mb-3">
                                <div class="form-group">
                                    <label class="label_title_textfield text-truncate fs-5">Municipio</label>
                                    <input [(ngModel)]="tutor.municipalityTitular" type="text" class="form-control fs-5"
                                        [formControl]="campoMunicipio" placeholder="" aria-describedby="basic-addon1">
                                </div>
                            </div>
                            <div class="col col-md-3 mb-3">
                                <div class="form-group">
                                    <label class="label_title_textfield text-truncate fs-5">Provincia</label>
                                    <input [(ngModel)]="tutor.cityTitular" type="text" class="form-control fs-5"
                                        [formControl]="campoProvincia" aria-describedby="basic-addon1">
                                </div>
                            </div>
                            <div class="col col-md-3 mb-3">
                                <div class="form-group">
                                    <label class="label_title_textfield text-truncate fs-5">País</label>
                                    <input [(ngModel)]="tutor.countryTitular" type="text" class="form-control fs-5"
                                        [formControl]="campoPais" aria-describedby="basic-addon1">
                                </div>
                            </div>
                        </div>
                        <div class="d-block d-md-flex">
                            <div class="col col-md-3 mb-3">
                                <label class="fs-5">Swift BIC</label>
                                <input [(ngModel)]="tutor.swiftBicTitular" type="text" class="form-control fs-5"
                                    placeholder="" aria-describedby="basic-addon1">
                            </div>
                            <div class="d-none d-md-flex col col-md-3 mb-3">
                                <div class="form-group">
                                    <label class="fs-5">Número de cuenta IBAN</label>
                                    <div class="d-block d-md-flex">
                                        <div class="col col-md-4 mb-1 p-0 pr-1">
                                            <input value="ES" type="text" class="form-control fs-5"
                                                aria-describedby="basic-addon1" disabled>
                                        </div>
                                        <div class="col col-md-4 mb-1 p-0 pr-1">
                                            <input [(ngModel)]="iban1" type="text" class="form-control fs-5"
                                                [formControl]="validacionIban1" onKeyPress="if(this.value.length==2) return false; 
                                                        var key = window.Event ? event.which : event.keyCode
                                                        return (key >= 48 && key <= 57)" maxlength="2"
                                                onkeyup="if (this.value.length == this.getAttribute('maxlength')) getElementById('iban2').focus();"
                                                (ngModelChange)="validarIBAN()" placeholder="XX"
                                                aria-describedby="basic-addon1">
                                        </div>
                                        <div class="col col-md-4 mb-1 p-0">
                                            <input [(ngModel)]="iban2" type="text" id="iban2" class="form-control fs-5"
                                                onKeyPress="if(this.value.length==4) return false;
                                                    var key = window.Event ? event.which : event.keyCode
                                                    return (key >= 48 && key <= 57)" maxlength="4"
                                                onkeyup="if (this.value.length == this.getAttribute('maxlength')) getElementById('iban3').focus();"
                                                (ngModelChange)="validarIBAN()" [formControl]="validacionIban2"
                                                placeholder="XXXX" aria-describedby="basic-addon1">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-none d-md-flex col col-md-6 mb-3">
                                <div class="d-block d-md-flex">
                                    <div class="col col-md-4 mb-1 p-0 pr-1">
                                        <label class="d-none d-md-block fs-5"><br></label>
                                        <input [(ngModel)]="iban3" id="iban3" type="text" class="form-control fs-5"
                                            onKeyPress="if(this.value.length==4) return false;
                                        var key = window.Event ? event.which : event.keyCode
                                        return (key >= 48 && key <= 57)" maxlength="4"
                                            onkeyup="if (this.value.length == this.getAttribute('maxlength')) getElementById('iban4').focus();"
                                            (ngModelChange)="validarIBAN()" [formControl]="validacionIban3"
                                            placeholder="XXXX" aria-describedby="basic-addon1">
                                    </div>
                                    <div class="col col-md-4 mb-1 p-0 pr-1">
                                        <label class="d-none d-md-block fs-5"><br></label>
                                        <input [(ngModel)]="iban4" id="iban4" type="text" class="form-control fs-5"
                                            onKeyPress="if(this.value.length==2) return false;
                                        var key = window.Event ? event.which : event.keyCode
                                        return (key >= 48 && key <= 57)" maxlength="2"
                                            onkeyup="if (this.value.length == this.getAttribute('maxlength')) getElementById('iban5').focus();"
                                            (ngModelChange)="validarIBAN()" [formControl]="validacionIban4"
                                            placeholder="XX" aria-describedby="basic-addon1">
                                    </div>
                                    <div class="col col-md-4 mb-1 p-0">
                                        <label class="d-none d-md-block fs-5"><br></label>
                                        <input [(ngModel)]="iban5" id="iban5" type="text" onKeyPress="if(this.value.length==10) return false;
                                            var key = window.Event ? event.which : event.keyCode
                                            return (key >= 48 && key <= 57)" maxlength="10"
                                            onkeyup="if (this.value.length == this.getAttribute('maxlength')) getElementById('pago').focus();"
                                            (ngModelChange)="validarIBAN()" class="form-control fs-5"
                                            [formControl]="validacionIban5" placeholder="XXXXXXXXXX"
                                            aria-describedby="basic-addon1">
                                    </div>
                                </div>
                            </div>

                            <div class="col d-md-none">
                                <label class="fs-5">Número de cuenta IBAN</label>
                                <div class="d-flex">
                                    <div class="col ml-0 pl-0 pr-1 mb-1">
                                        <input value="ES" type="text" class="form-control fs-5"
                                            aria-describedby="basic-addon1" disabled>
                                    </div>
                                    <div class="col px-1 mb-1">
                                        <input [(ngModel)]="iban1" type="text" class="form-control fs-5"
                                            [formControl]="validacionIban1" onKeyPress="if(this.value.length==2) return false; 
                                                    var key = window.Event ? event.which : event.keyCode
                                                    return (key >= 48 && key <= 57)" maxlength="2"
                                            onkeyup="if (this.value.length == this.getAttribute('maxlength')) getElementById('iban2').focus();"
                                            (ngModelChange)="validarIBAN()" placeholder="XX"
                                            aria-describedby="basic-addon1">
                                    </div>
                                    <div class="col px-1 mb-1">
                                        <input [(ngModel)]="iban2" type="text" id="iban2" class="form-control fs-5"
                                            onKeyPress="if(this.value.length==4) return false;
                                                var key = window.Event ? event.which : event.keyCode
                                                return (key >= 48 && key <= 57)" maxlength="4"
                                            onkeyup="if (this.value.length == this.getAttribute('maxlength')) getElementById('iban3').focus();"
                                            (ngModelChange)="validarIBAN()" [formControl]="validacionIban2"
                                            placeholder="XXXX" aria-describedby="basic-addon1">
                                    </div>
                                    <div class="col px-1 mb-1">
                                        <input [(ngModel)]="iban3" id="iban3" type="text" class="form-control fs-5"
                                            onKeyPress="if(this.value.length==4) return false;
                                        var key = window.Event ? event.which : event.keyCode
                                        return (key >= 48 && key <= 57)" maxlength="4"
                                            onkeyup="if (this.value.length == this.getAttribute('maxlength')) getElementById('iban4').focus();"
                                            (ngModelChange)="validarIBAN()" [formControl]="validacionIban3"
                                            placeholder="XXXX" aria-describedby="basic-addon1">
                                    </div>
                                    <div class="col mr-0 pr-0 pl-1 mb-1">
                                        <input [(ngModel)]="iban4" id="iban4" type="text" class="form-control fs-5"
                                            onKeyPress="if(this.value.length==2) return false;
                                        var key = window.Event ? event.which : event.keyCode
                                        return (key >= 48 && key <= 57)" maxlength="2"
                                            onkeyup="if (this.value.length == this.getAttribute('maxlength')) getElementById('iban5').focus();"
                                            (ngModelChange)="validarIBAN()" [formControl]="validacionIban4"
                                            placeholder="XX" aria-describedby="basic-addon1">
                                    </div>
                                </div>
                            </div>


                            <div class="d-flex d-md-none my-2">
                                <div class="col">
                                    <input [(ngModel)]="iban5" id="iban5" type="text" onKeyPress="if(this.value.length==10) return false;
                                            var key = window.Event ? event.which : event.keyCode
                                            return (key >= 48 && key <= 57)" maxlength="10"
                                        onkeyup="if (this.value.length == this.getAttribute('maxlength')) getElementById('pago').focus();"
                                        (ngModelChange)="validarIBAN()" class="form-control fs-5"
                                        [formControl]="validacionIban5" placeholder="XXXXXXXXXX"
                                        aria-describedby="basic-addon1">
                                </div>
                            </div>
                        </div>
                        <div class="d-block d-md-flex">
                            <div class="col col-md-3 mb-3">
                                <div class="form-group">
                                    <label class="label_title_textfield text-truncate fs-5">Tipo de pago</label>
                                    <select class="form-control fs-5" [(ngModel)]="tutor.paymentType">
                                        <option>Seleccione</option>
                                        <option value="Pago recurrente">Pago
                                            recurrente (Pago mes a mes)</option>
                                        <option value="Pago único">Pago único
                                            (Pago completo anual)</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col col-md-3 mb-3">
                                <div class="form-group">
                                    <label class="label_title_textfield text-truncate fs-5">Fecha</label>
                                    <input [(ngModel)]="fechaAMostrar" [formControl]="campoFecha" type="text"
                                        class="form-control fs-5" placeholder="" aria-describedby="basic-addon1"
                                        disabled>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="padding-top: 5%" *ngIf="!visibleSepa">
                        <app-redsys [dsMerchantParameters]="dsMerchantParameters" [dsSignature]="dsSignature">
                        </app-redsys>
                    </div>
                    <div class="d-flex justify-content-between py-2">
                        <button (click)="banderaBotonSiguiente=true" type="button"
                            class="btn btn-outline-secondary btn-lg">Atrás</button>
                        <button type="button" class="btn btn-secondary btn-lg" [disabled]="campoNombre.invalid || campoDireccion.invalid || 
                    campoMunicipio.invalid || validacionIban1.invalid || campoProvincia.invalid 
                    || campoPais.invalid || validacionIban1.invalid || validacionIban2.invalid
                    || validacionIban3.invalid || validacionIban4.invalid || validacionIban5.invalid 
                    || campoNumeroDocumento.invalid || campoFecha.invalid || !documentoValido" [ngClass]="{'opacity-1': campoNombre.invalid || campoDireccion.invalid || 
                        campoMunicipio.invalid || validacionIban1.invalid || campoProvincia.invalid 
                        || campoPais.invalid || validacionIban1.invalid || validacionIban2.invalid
                        || validacionIban3.invalid || validacionIban4.invalid || validacionIban5.invalid 
                        || campoNumeroDocumento.invalid || campoFecha.invalid || !documentoValido}"
                            (click)="guadarInfoDomiciliacionBancaria()" data-toggle="modal" data-target="#exampleModal"
                            *ngIf="visibleSepa">Pagar</button>
                    </div>
                </div>
            </div>
            <!-- Modal -->
            <div *ngIf="!ibanValido">
                <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog"
                    aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLabel">Error</h5>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                Verifique el número IBAN
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="!banderaFinalizacion">
                <div class="title_center mb-3">
                    <label class="fs-5">Mensaje <span class="vag-bold-font text-uppercase">WEB</span></label>
                </div>
                <div class="d-flex justify-content-center">
                    <div class="d-none d-lg-flex col-lg-4">
                        <img src="../../assets/img/mascota.png" style="max-width: 80%;" alt="">
                    </div>
                    <div class="col-12 col-lg-8">
                        <h1>¡Gracias por la inscripción!</h1>
                        <span class="fs-2">Os esperamos en Playbots para el inicio del curso.</span>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-end py-5">
                <button *ngIf="!banderaFinalizacion" class="btn btn-outline-secondary btn-lg"
                    (click)="logout()">Finalizar</button>
            </div>

            <div class="modal fade" id="exampleModal2" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2"
                aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">PROMOCIÓN TARJETA 5</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p>Benefíciate de la promoción Tarjeta 5 seleccionando tarjeta bancaria como método de pago.
                            </p>


                            <h6>¿CÓMO FUNCIONA?</h6>
                            <br>
                            Seleccionando la opción Tarjeta, cada mes recibirás un correo electrónico con un link de
                            pago online aplicando un descuento de 5€ sobre tu mensualidad.
                            <br>
                            Para que se aplique el descuento, debes realizar el pago entre los días 1 y 5 de cada mes.


                            <br>
                            Si tu recibo no es abonado en los días indicados, recibirás otro link de pago online con la
                            cuota íntegra sin descuentos.

                            <ul>
                                <li>Promoción aplicable solo a cuotas mensuales completas por valor de 55€.</li>
                                <li>No acumulable a otros descuentos o promociones.</li>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>